"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimelineContext = void 0;
var react_1 = require("react");
exports.TimelineContext = react_1.createContext({});
exports.TimelineContext.displayName = "TimelineContext";
//# sourceMappingURL=TimelineContext.js.map